import { getApiUrl } from "src/common/api/getUrl";
import { parsePaginationResponse } from "src/common/parsePaginationResponse";
import { rest } from "src/common/rest";
import { RtRequest } from "src/components/ReactiveTable/RtRequest";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";

import { formExtensionsToWrite } from "../extensionBindings";
import {
  ClassifierFilters,
  ZClassifier,
  zClassifier,
  ZClassifierCard,
} from "./ZClassifier";

// https://mdm2-dev-magnit.d4r.int/api/swagger-ui/index.html#/Classifier%20API/getClassifiers

const urlClassifiers = (path: string = "") =>
  getApiUrl(`/core/classifiers${path}`);

export const classifiersLoader = async ({
  filters,
  page,
  pageSize,
}: RtRequest<ClassifierFilters>): Promise<RtResponse<ZClassifier>> => {
  const resp = await rest.get(urlClassifiers(), {
    params: { ...filters, page, size: pageSize },
  });
  return parsePaginationResponse(
    resp.data,
    zClassifier,
    "classifiers response",
  );
};

export const loadClassifier = async (id: string): Promise<ZClassifier> => {
  const resp = await rest.get(urlClassifiers(`/${id}`));
  return zClassifier.parse(resp.data);
};

type SavedClsCard = Omit<ZClassifierCard, "extensions" | "schemas"> & {
  schemaIds: string[];
  extensions?: ReturnType<typeof formExtensionsToWrite>;
};

const card2saved = (src: ZClassifierCard): SavedClsCard => {
  const { schemas, extensions, ...restData } = src;
  return {
    ...restData,
    schemaIds: schemas ? [schemas.id] : [],
    extensions: formExtensionsToWrite(extensions ?? []),
  };
};

export const createClassifier = async (
  data: ZClassifierCard,
): Promise<ZClassifier> => {
  const resp = await rest.post(urlClassifiers(), card2saved(data));
  return zClassifier.parse(resp.data);
};

export const saveClassifier = async (
  id: string,
  data: ZClassifierCard,
): Promise<ZClassifier> => {
  const resp = await rest.put(urlClassifiers(`/${id}`), card2saved(data));
  return zClassifier.parse(resp.data);
};

export const deleteCassifiers = async (ids: string[]) => {
  await rest.delete(urlClassifiers(), {
    data: { ids },
  });
};

export const deleteSingleCassifier = async (id: string): Promise<void> => {
  await rest.delete(urlClassifiers(`/${id}`));
};
